module.exports = __webpack_public_path__ + "media/这么多年了，我都替你不值 (电影《我要我们在一起》配乐).8c8e8883.mp3";